import { APP_URL } from "@bodhistreams/ui";
import { useNavigate } from "react-router-dom";
import "./FinalCTA.css";

const META = ["No hardware required", "Setup in minutes", "Cancel anytime"];

const FinalCTA = () => {
	const navigate = useNavigate();

	const handleStart = () => {
		window.location.href = `${APP_URL}/login`;
	};

	const handleSeePricing = () => {
		navigate("/pricing");
	};

	return (
		<section className="final-cta">
			<p className="final-cta-subtitle">
				BodhiStreams brings together original wellness music composed in 432 Hz,
				mood-curated libraries, and multi-zone control under a single,
				considered platform, built for hospitality, wellness, and devotional
				practice. Create your account, configure your first zone in minutes, and
				let your guests step into a quieter rhythm from the moment they arrive.
			</p>

			<h3 className="final-cta-headline">Start your streaming today.</h3>

			<div className="final-cta-actions">
				<button
					type="button"
					className="final-cta-btn is-primary"
					onClick={handleStart}
				>
					Start Free Trial
					<span className="final-cta-btn-arrow">→</span>
				</button>
				<button
					type="button"
					className="final-cta-btn"
					onClick={handleSeePricing}
				>
					Compare Plans
				</button>
			</div>

			<div className="final-cta-meta">
				{META.map((item) => (
					<span key={item} className="final-cta-meta-item">
						{item}
					</span>
				))}
			</div>
		</section>
	);
};

export default FinalCTA;
